import {IUiServices} from "@kta20-core/interfaces/i-ui-services";


export abstract class BaseGlobalErrorHandler {
    abstract onError(err:Error);
    abstract onUnhandledRejection(event:Event);

    protected uiService:IUiServices;
}
